import React from 'react';
import './Terms.css';

const TermsOfService = () => {
  return (
    <div className="terms-container">
      <h1 className="terms-title">Terms of Service</h1>
      
      <section className="terms-section">
        <h2 className="terms-heading">1. Free Service and Promotion Options</h2>
        <p>
          CoinStatsHub.tech is a free service that provides relevant information to users at no cost. Additionally, there
          are optional promotion services for projects seeking greater visibility on the platform.
        </p>
      </section>

      <section className="terms-section">
        <h2 className="terms-heading">2. Burning of Payments in Promotions</h2>
        <p>
          All payments made in FUEC for promotion services are directly burned at the official burn address,{' '}
          <strong>FEVimFGLThhSYKRvassLGx58DWKUJAAMgD</strong>, generating no profit for the CoinStatsHub.tech team. This
          practice ensures that the value of these payments returns to the community.
        </p>
      </section>

      <section className="terms-section">
        <h2 className="terms-heading">3. Limitation of Liability</h2>
        <p>
          CoinStatsHub.tech is provided "as is" and without any warranties. We are not liable for any damages, data loss,
          or harm that may result from using our platform or promotion services. The user agrees to use the service at
          their own risk.
        </p>
      </section>

      <section className="terms-section">
        <h2 className="terms-heading">4. Updates and Changes</h2>
        <p>
          CoinStatsHub.tech reserves the right to modify or update these terms at any time without prior notice. Users are
          responsible for periodically reviewing these terms to stay informed of any changes.
        </p>
      </section>

      <section className="terms-section">
        <h2 className="terms-heading">5. Usage Rights</h2>
        <p>
          The data and information provided by CoinStatsHub.tech are for informational purposes only and should not be
          considered as financial, legal, or investment advice.
        </p>
      </section>

      <p className="terms-footer">
        By using CoinStatsHub.tech, you accept these Terms of Service and acknowledge that you understand and agree to
        the limitations outlined here, as well as the burn policy for promotion services.
      </p>
    </div>
  );
};

export default TermsOfService;
